import { useNavigate } from "react-router-dom";
import { ChartIcon, LayersIcon } from "../Icons";
import "./Home.css";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <div className="page-header">
        <p className="page-eyebrow">Novonesis Application</p>
        <h1 className="page-title">Análises disponíveis</h1>
        <p className="page-desc">
          Selecione o tipo de análise que deseja realizar.
        </p>
      </div>

      <div className="home-cards">
        <button
          type="button"
          className="analysis-card"
          onClick={() => navigate("/nova-analise")}
        >
          <span className="analysis-card-icon"><ChartIcon size={26} /></span>
          <span className="analysis-card-title">Granulometria</span>
          <span className="analysis-card-desc">
            Análise granulométrica de grãos de coalhada via visão computacional.
          </span>
        </button>

        <div className="analysis-card disabled" aria-disabled="true">
          <span className="analysis-card-icon"><LayersIcon size={26} /></span>
          <span className="analysis-card-title">Outra Análise</span>
          <span className="analysis-card-desc">Reservado para futuras evoluções.</span>
        </div>
      </div>
    </div>
  );
}
